
import {
  getAdminCourierTransferCandidates,
  adminCourierTransfer,
  adminCourierReturnToPool,
} from '@/api/order'

export default {
  name: 'AdminCourierTransferDialog',
  props: {
    visible: { type: Boolean, default: false },
    orderId: { type: [Number, String], default: null },
    hasCourier: { type: Boolean, default: false },
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      candidates: [] as any[],
      storeManagers: [] as any[],
      managerAcceptDelivery: 0,
    }
  },
  computed: {
    showReturn(): boolean {
      return this.hasCourier
    },
    managerParticipates(): boolean {
      return Number(this.managerAcceptDelivery) === 1
    },
    returnPoolManager(): any {
      const list = Array.isArray(this.storeManagers) ? this.storeManagers : []
      return list.length ? list[0] : null
    },
    showReturnPoolRow(): boolean {
      return this.showReturn && !this.managerParticipates && !!this.returnPoolManager
    },
    displayList(): any[] {
      const seen: Record<string, boolean> = {}
      const out: any[] = []
      ;(Array.isArray(this.candidates) ? this.candidates : []).forEach((c) => {
        if (!c || c.id == null || seen[String(c.id)]) return
        seen[String(c.id)] = true
        out.push(c)
      })
      return out
    },
  },
  watch: {
    visible(val: boolean) {
      this.innerVisible = val
      if (val && this.orderId) {
        this.loadCandidates()
      }
      if (!val) {
        this.candidates = []
        this.storeManagers = []
        this.managerAcceptDelivery = 0
      }
    },
    innerVisible(val: boolean) {
      if (!val) {
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    },
  },
  methods: {
    handleClose() {
      this.innerVisible = false
    },
    showStoreName(c: any) {
      if (!c || !c.storeName) return false
      if (Number(c.role) === 1 || c.roleName === '店长') return false
      return true
    },
    parseCandidatesPayload(data: any) {
      if (Array.isArray(data)) {
        return { candidates: data, storeManagers: [] as any[], managerAcceptDelivery: 0 }
      }
      if (data && typeof data === 'object') {
        return {
          candidates: Array.isArray(data.candidates) ? data.candidates : [],
          storeManagers: Array.isArray(data.storeManagers) ? data.storeManagers : [],
          managerAcceptDelivery:
            data.managerAcceptDelivery != null ? Number(data.managerAcceptDelivery) : 0,
        }
      }
      return { candidates: [] as any[], storeManagers: [] as any[], managerAcceptDelivery: 0 }
    },
    async loadCandidates() {
      if (!this.orderId) return
      this.loading = true
      try {
        const res: any = await getAdminCourierTransferCandidates(this.orderId)
        if (String(res.data.code) === '1') {
          const parsed = this.parseCandidatesPayload(res.data.data)
          this.candidates = parsed.candidates
          this.storeManagers = parsed.storeManagers
          this.managerAcceptDelivery = parsed.managerAcceptDelivery
        } else {
          this.candidates = []
          this.storeManagers = []
          this.managerAcceptDelivery = 0
          this.$message.error(res.data.msg || '加载失败')
        }
      } catch (e) {
        this.candidates = []
        this.storeManagers = []
        this.managerAcceptDelivery = 0
      } finally {
        this.loading = false
      }
    },
    handlePick(c: any) {
      if (!c || !c.id) return
      const name = c.name || '该人员'
      const roleTip = c.roleName ? `（${c.roleName}）` : ''
      const storeTip =
        this.showStoreName(c) && c.storeName ? `\n所属：${c.storeName}` : ''
      const actionLabel = this.hasCourier ? '转派' : '指派'
      this.$confirm(`确定${actionLabel}给 ${name}${roleTip}？${storeTip}`, `确认${actionLabel}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res: any = await adminCourierTransfer(this.orderId!, { targetCourierId: c.id })
        if (String(res.data.code) === '1') {
          this.$message.success(`${actionLabel}成功`)
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(res.data.msg || `${actionLabel}失败`)
        }
      }).catch(() => {})
    },
    handleReturn() {
      const mgr = this.returnPoolManager
      const name = (mgr && mgr.name) || '店长'
      this.$confirm(`确定将订单收回至待派单，由店长 ${name} 重新分配？`, '确认收回', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res: any = await adminCourierReturnToPool(this.orderId!)
        if (String(res.data.code) === '1') {
          this.$message.success('已收回待派单')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      }).catch(() => {})
    },
  },
}
